import { Field, WrappedFieldArrayProps } from "redux-form";
import { Button } from "rsuite";
import LegacyTrashIcon from "@rsuite/icons/legacy/Trash";
import InputWithLabel from "shared/components/redux-form/InputWithLabel";
import { maxLength, onlyNumber } from "core/utils/Normalizer";

export default function StorePriceDenomination({
  fields,
  title,
}: WrappedFieldArrayProps<any> & { title?: string }) {
  return (
    <>
      <div className="custom-field-header">
        <div className="fragment-title">
          <div className="section-title">{title}</div>
        </div>
        <Button appearance="primary" onClick={() => fields.push({})}>
          Add Field
        </Button>
      </div>

      {fields.map((cf, index) => {
        return (
          <div key={index} className="custom-field-wrapper">
            <div className="custom-field-number">{`Price ${index + 1}`}</div>

            <div className="custom-field-grid">
              {/* Key */}
              <Field
                name={`${cf}.unit`}
                component={InputWithLabel}
                placeholder="Enter Unit"
                label="Unit"
                normalize={(value: string) => maxLength(value, 20)}
              />
              <Field
                name={`${cf}.price`}
                component={InputWithLabel}
                placeholder="Enter Price"
                label="Price"
                normalize={(value: string) => onlyNumber(value, 0, 10000, true)}
              />{" "}
              <Field
                name={`${cf}.discountPrice`}
                component={InputWithLabel}
                placeholder="Enter DiscountPrice"
                label="DiscountPrice"
                normalize={(value: string) => onlyNumber(value, 0, 10000, true)}
              />
            </div>

            <div className="custom-field-delete">
              <Button
                onClick={() => fields.remove(index)}
                appearance="primary"
                className="delete-btn"
              >
                <LegacyTrashIcon />
                <p>Delete</p>
              </Button>
            </div>
          </div>
        );
      })}
    </>
  );
}
